import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cdba-browser-support-dialog',
  templateUrl: './browser-support-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BrowserSupportDialogComponent {}
